// Axios rejects non-2xx responses: https://axios-http.com/docs/handling_errors
// Fixed text avoids displaying backend internals; no guessed cooldown timer.
export const getPaymentLimitMessage = error => {
  if (error?.response?.status === 429) return "Too many payment attempts. Please wait before trying again.";
  if (error?.response?.status === 503) return "Payment service is temporarily unavailable. Please try again later.";
  return null;
};
